import { Link } from "react-router-dom";
import { CheckBox } from "../CheckBox";
import styles from "./PolicyCheckbox.module.scss";
import { FormikProps } from "formik";

export const PolicyCheckbox = ({ formik }: { formik: FormikProps<any> }) => {
  return (
    <div className={styles.formSection}>
      <CheckBox
        id="acceptTerms"
        lable={
          <span className={styles.checkboxText}>
            Продолжая, вы подтверждаете, что ознакомлены и согласны с условиями{' '}
            <Link to="/privacy-policy" className={styles.checkboxLink} target="_blank" rel="noopener noreferrer">
              политики конфиденциальности
            </Link>
            {' '}и{' '}
            <Link to="/rules" className={styles.checkboxLink} target="_blank" rel="noopener noreferrer">
              правила клуба
            </Link>
          </span>
        }
        checked={formik.values.acceptTerms}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          formik.setFieldValue("acceptTerms", e.target.checked);
        }}
      />
    </div>
  );
};